module.exports = __webpack_public_path__ + "static/media/icon_card_car.3a0aa6a3.svg";